import React from 'react';
import PropTypes from 'prop-types';
import Menu from './Menu';
import '../css/Header.css';
import {withRouter} from 'react-router-dom';
import {PageAction} from '../actions';
import {PageStore} from '../stores';
import _ from 'lodash';
/**
 * Header component
 */
class Header extends React.Component {
  static displayName = 'Header';
  static propTypes = {
    className: PropTypes.string,
    store: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    section: PropTypes.string,
  };
  static defaultProps = {
    section: null,
  };

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = 'Header';
    this.unselectTag = this.unselectTag.bind(this);
    this.toggleTag = this.toggleTag.bind(this);
  }
  /**
   * @return {void} go back to home page
   * @param {string} tag
   */
  unselectTag(tag) {
    this.props.history.push('/');
  }

  /**
  * Show a specific tag
  * @param {string} tag
  * @return {void}
  */
  toggleTag(tag) {
    const match = _.first(
      this.props.store.Router.filter(
        (p) =>
          p.type === 'TagPage' &&
          p.menuTitle.toUpperCase() === tag.toUpperCase()
      )
    );
    if (!match) {
      console.error('Tag ', tag, ' is unknown');
      return null;
    }
    this.props.history.push(match.relativeLink);
  }
  /**
   * The header updated, maybe we changed the menu state.
   * @param {object} nextProps
   * @param {object} nextState
   */
  componentWillReceiveProps(nextProps) {
    const isOpen = PageStore.isMenuOpen();

    const body = document.querySelectorAll('body')[0];
    if (!isOpen) {
      body.className = body.className.replace(
        new RegExp(
          '(^|\\b)' + 'no-scroll'.split(' ').join('|') + '(\\b|$)',
          'gi'
        ),
        ' '
      );
    } else {
      body.className += ' no-scroll';
    }
  }

  /**
 * @override
 */
  render() {
    return (
      <div
        className={`${this.className} ${this.props.className ||
          ''} ${PageStore.isMenuOpen() ? 'menuOpen' : 'menuClose'}`}
      >
        <a className={`${this.className}__logo`} href="/">
          <div>
            Aeby<br />&<br />Associés
          </div>
          <div>
            Perneger<br />
            <br />SA
          </div>
        </a>
        <div
          className={`${this.className}__menu`}
          onClick={PageAction.toggleMenu}
        >
          <svg
            style={{
              width: '24px',
              height: '24px',
              position: 'relative',
              left: '-4px',
            }}
            viewBox="0 0 24 24"
          >
            <path
              fill="#000000"
              d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z"
            />
          </svg>
        </div>
        <Menu
          {...this.props}
          Projects={this.props.store.Projects}
          isMenuOpen={PageStore.isMenuOpen()}
          closeMenu={PageAction.toggleMenu}
          toggleTag={this.toggleTag}
          unselectTag={this.unselectTag}
        />
      </div>
    );
  }
}

export default withRouter(Header);
